import { memo } from "react";

import CurrentUserAvatar from "../../CurrentUserAvatar";
import styles from "./index.module.scss";
import { useClassNames, useEmployeeData } from "../../../shared/hooks";
import SearchBar from "../SearchBar";

type HeaderProps = {
  hideSearch?: boolean;
};

const Header = ({ hideSearch }: HeaderProps) => {
  const classNames = useClassNames([
    styles.Header,
    hideSearch ? styles["Header--hideSearch"] : "",
  ]);

  const employee = useEmployeeData();

  return (
    <header className={classNames}>
      {employee && (
        <>
          {!hideSearch && <SearchBar />}
          <CurrentUserAvatar employeeInfo={employee} />
        </>
      )}
    </header>
  );
};

export default memo(Header);
